export function getCurrentUrl(pathname: string) {
  const parts = pathname.split('/')
  if (parts.length > 1) {
    return `/${parts[1]}`
  }
  return pathname
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  if (current.indexOf(url) > -1) {
    return true
  }

  return false
}
